import { render, staticRenderFns } from "./details.vue?vue&type=template&id=0b590bba&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=0b590bba&prod&lang=less&"
import style1 from "./details.vue?vue&type=style&index=1&id=0b590bba&prod&lang=css&"
import style2 from "./details.vue?vue&type=style&index=2&id=0b590bba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b590bba",
  null
  
)

export default component.exports